"use client"

import { Modal } from "src/components/generic/Modal"
import { ProductImages } from "src/components/product-details/ProductImages"
import { ResolvedAccessoryProductData } from "src/data/product-accessories-resolved/types"
import { formatPriceLong } from "src/utilities/price"

export type AccessoryDetailsModalProps = {
  accessory: ResolvedAccessoryProductData
  onClose: () => void
}

export const AccessoryDetailsModal = ({ accessory, onClose: close }: AccessoryDetailsModalProps) => {
  return (
    <Modal className="z-add-to-cart-modal" onClose={close}>
      <div className="max-h-full w-full overflow-y-auto">
        <div className="flex size-full flex-col items-center gap-8 p-4 pb-8 md:flex-row md:justify-center md:p-8">
          <div className="w-full max-w-100">
            <ProductImages name={accessory.name} images={accessory.images} />
          </div>

          <div className="flex flex-col items-start gap-4 md:w-100">
            <div className="font-product text-h2-np">{accessory.name}</div>
            <div className="text-h4-np">{formatPriceLong(accessory.price)}</div>
            {accessory.description && (
              <div className="text-base md:text-lg" dangerouslySetInnerHTML={{ __html: accessory.description }} />
            )}
          </div>
        </div>
      </div>
    </Modal>
  )
}
